import { render, staticRenderFns } from "./ProposalFormFooter.vue?vue&type=template&id=7c19c6fe&scoped=true&"
import script from "./ProposalFormFooter.vue?vue&type=script&lang=js&"
export * from "./ProposalFormFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19c6fe",
  null
  
)

export default component.exports